export enum PingPongButtonTypeEnum {
  CONFIRM = 'CONFIRM',
  LOAD_QUOTATION = 'LOAD_QUOTATION',
  CONFIRM_BOOKING = 'CONFIRM_BOOKING',
  WAITING = 'WAITING',
  CONTACT_ADMIN = 'CONTACT_ADMIN',
  PAYMENT = 'PAYMENT',
  QUOTATION_PAID = 'QUOTATION_PAID',
  PAYMENT_DONE = 'PAYMENT_DONE',
  ADMIN_NEXT_STEP = 'ADMIN_NEXT_STEP',
  SUPER_ADMIN_NEXT_STEP = 'SUPER_ADMIN_NEXT_STEP',
  ADMIN_PREVIOUS_STEP = 'ADMIN_PREVIOUS_STEP',
  SUPER_ADMIN_PREVIOUS_STEP = 'SUPER_ADMIN_PREVIOUS_STEP',
  GIVE_FEEDBACK = 'GIVE_FEEDBACK',
  WAITING_STEP_ONE = 'WAITING_STEP_ONE',
  ASK_CHANGE_DATES = 'ASK_CHANGE_DATES',
  DECLINED_BY_OWNER = 'DECLINED_BY_OWNER',
  DECLINED_BY_USER_ADMIN = 'DECLINED_BY_USER_ADMIN',
  HOUSE_NOT_AVAILABLE = 'HOUSE_NOT_AVAILABLE',
  CONFIRMED_BY_OWNER = 'CONFIRMED_BY_OWNER',
  MODIFY_QUOTATION = 'MODIFY_QUOTATION',
}
